import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus } from "lucide-react";
import VoiceCard from "@/components/jammable/VoiceCard";
import { addMyVoice } from "@/lib/jammableApi";
import { safeApiError } from "@/lib/safeErrorText";

/** Voices you saved or used before (your own trained Jammable voices go here), plus "add by link or ID". */
export default function MyVoices({ voices, selected, onPick, onRemove, onAdded }) {
  const [ref, setRef] = useState("");
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (!ref.trim()) return;
    setBusy(true);
    try {
      const v = await addMyVoice(ref.trim());
      setRef("");
      onAdded(v);
      toast.success(`${v.name} added to My voices`);
    } catch (e) { toast.error("Couldn't add that voice", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="jam-my-voices">
      <div className="grid max-h-64 gap-2 overflow-y-auto pr-1 sm:grid-cols-2">
        {voices.map((v) => <VoiceCard key={v.id} voice={v} selected={selected?.id === v.id} onPick={onPick} onRemove={onRemove} />)}
      </div>
      {!voices.length ? <p data-testid="jam-my-empty" className="text-[12px] text-white/55">No voices saved yet. Find one in “Find a voice”, or add your own trained Jammable voice below.</p> : null}
      <div className="mt-3 flex gap-2">
        <input data-testid="jam-add-input" value={ref} onChange={(e) => setRef(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Your voice's Jammable link or ID" className="min-w-0 flex-1 rounded-xl border border-white/10 bg-black/40 px-3 py-2 text-[13px] text-white focus:border-fuchsia-300/50 focus:outline-none" />
        <button type="button" data-testid="jam-add-btn" onClick={add} disabled={busy || !ref.trim()} className="inline-flex items-center gap-1.5 rounded-xl border border-fuchsia-300/40 bg-fuchsia-500/15 px-3 py-2 font-mono text-[11px] uppercase tracking-wider text-fuchsia-50 disabled:opacity-40">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Plus className="h-3.5 w-3.5" />} Add
        </button>
      </div>
    </div>
  );
}
